// @generated by protoc-gen-es v2.6.2 with parameter "target=ts"
// @generated from file bff/v1/admin.proto (package bff.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ApiKey, ApiKeyRole, BillingEmail, Language, Member, MemberRole, Term } from "./model_pb";
import { file_bff_v1_model } from "./model_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bff/v1/admin.proto.
 */
export const file_bff_v1_admin: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bff_v1_model, file_google_protobuf_timestamp]);

/**
 * @generated from message bff.v1.SendInvitationRequest
 */
export type SendInvitationRequest = Message<"bff.v1.SendInvitationRequest"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;
};

/**
 * Describes the message bff.v1.SendInvitationRequest.
 * Use `create(SendInvitationRequestSchema)` to create a new message.
 */
export const SendInvitationRequestSchema: GenMessage<SendInvitationRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 0);

/**
 * @generated from message bff.v1.SendInvitationResponse
 */
export type SendInvitationResponse = Message<"bff.v1.SendInvitationResponse"> & {
};

/**
 * Describes the message bff.v1.SendInvitationResponse.
 * Use `create(SendInvitationResponseSchema)` to create a new message.
 */
export const SendInvitationResponseSchema: GenMessage<SendInvitationResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 1);

/**
 * @generated from message bff.v1.GetMemberRequest
 */
export type GetMemberRequest = Message<"bff.v1.GetMemberRequest"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;
};

/**
 * Describes the message bff.v1.GetMemberRequest.
 * Use `create(GetMemberRequestSchema)` to create a new message.
 */
export const GetMemberRequestSchema: GenMessage<GetMemberRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 2);

/**
 * @generated from message bff.v1.GetMemberResponse
 */
export type GetMemberResponse = Message<"bff.v1.GetMemberResponse"> & {
  /**
   * @generated from field: bff.v1.Member member = 1;
   */
  member?: Member;
};

/**
 * Describes the message bff.v1.GetMemberResponse.
 * Use `create(GetMemberResponseSchema)` to create a new message.
 */
export const GetMemberResponseSchema: GenMessage<GetMemberResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 3);

/**
 * @generated from message bff.v1.SaveMemberRequest
 */
export type SaveMemberRequest = Message<"bff.v1.SaveMemberRequest"> & {
  /**
   * メンバーID
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * 所属組織ID
   *
   * @generated from field: string organizationId = 2;
   */
  organizationId: string;

  /**
   * メンバーのメールアドレス
   *
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * メンバーの電話番号
   *
   * @generated from field: string phoneNumber = 4;
   */
  phoneNumber: string;

  /**
   * メンバーの携帯電話番号
   *
   * @generated from field: string mobileNumber = 5;
   */
  mobileNumber: string;

  /**
   * メンバーの役割
   *
   * @generated from field: bff.v1.MemberRole role = 6;
   */
  role: MemberRole;

  /**
   * メンバー名
   *
   * @generated from field: string name = 7;
   */
  name: string;

  /**
   * ユーザーロールコード
   *
   * @generated from field: repeated string userRoleCodes = 8;
   */
  userRoleCodes: string[];

  /**
   * 言語設定
   *
   * @generated from field: bff.v1.Language language = 9;
   */
  language: Language;

  /**
   * メンバー名(英語表記)
   *
   * @generated from field: optional string englishName = 10;
   */
  englishName?: string;

  /**
   * 編集前に表示したメンバー情報
   *
   * @generated from field: bff.v1.Member observed = 11;
   */
  observed?: Member;
};

/**
 * Describes the message bff.v1.SaveMemberRequest.
 * Use `create(SaveMemberRequestSchema)` to create a new message.
 */
export const SaveMemberRequestSchema: GenMessage<SaveMemberRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 4);

/**
 * @generated from message bff.v1.SaveMemberResponse
 */
export type SaveMemberResponse = Message<"bff.v1.SaveMemberResponse"> & {
  /**
   * @generated from field: bff.v1.Member member = 1;
   */
  member?: Member;
};

/**
 * Describes the message bff.v1.SaveMemberResponse.
 * Use `create(SaveMemberResponseSchema)` to create a new message.
 */
export const SaveMemberResponseSchema: GenMessage<SaveMemberResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 5);

/**
 * 規約への同意リクエスト
 *
 * @generated from message bff.v1.AgreeToTermRequest
 */
export type AgreeToTermRequest = Message<"bff.v1.AgreeToTermRequest"> & {
  /**
   * @generated from field: repeated bff.v1.Term terms = 1;
   */
  terms: Term[];
};

/**
 * Describes the message bff.v1.AgreeToTermRequest.
 * Use `create(AgreeToTermRequestSchema)` to create a new message.
 */
export const AgreeToTermRequestSchema: GenMessage<AgreeToTermRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 6);

/**
 * 規約への同意レスポンス
 *
 * @generated from message bff.v1.AgreeToTermResponse
 */
export type AgreeToTermResponse = Message<"bff.v1.AgreeToTermResponse"> & {
};

/**
 * Describes the message bff.v1.AgreeToTermResponse.
 * Use `create(AgreeToTermResponseSchema)` to create a new message.
 */
export const AgreeToTermResponseSchema: GenMessage<AgreeToTermResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 7);

/**
 * 規約一覧リクエスト
 *
 * @generated from message bff.v1.ListPendingTermsRequest
 */
export type ListPendingTermsRequest = Message<"bff.v1.ListPendingTermsRequest"> & {
};

/**
 * Describes the message bff.v1.ListPendingTermsRequest.
 * Use `create(ListPendingTermsRequestSchema)` to create a new message.
 */
export const ListPendingTermsRequestSchema: GenMessage<ListPendingTermsRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 8);

/**
 * 規約一覧レスポンス
 *
 * @generated from message bff.v1.ListPendingTermsResponse
 */
export type ListPendingTermsResponse = Message<"bff.v1.ListPendingTermsResponse"> & {
  /**
   * @generated from field: repeated bff.v1.Term terms = 1;
   */
  terms: Term[];
};

/**
 * Describes the message bff.v1.ListPendingTermsResponse.
 * Use `create(ListPendingTermsResponseSchema)` to create a new message.
 */
export const ListPendingTermsResponseSchema: GenMessage<ListPendingTermsResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 9);

/**
 * 全体送付先 + プロダクト個別送付先の一覧取得のリクエスト
 *
 * @generated from message bff.v1.ListBillingEmailsRequest
 */
export type ListBillingEmailsRequest = Message<"bff.v1.ListBillingEmailsRequest"> & {
  /**
   * 組織ID
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message bff.v1.ListBillingEmailsRequest.
 * Use `create(ListBillingEmailsRequestSchema)` to create a new message.
 */
export const ListBillingEmailsRequestSchema: GenMessage<ListBillingEmailsRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 10);

/**
 * 全体送付先 + プロダクト個別送付先の一覧取得のレスポンス
 *
 * @generated from message bff.v1.ListBillingEmailsResponse
 */
export type ListBillingEmailsResponse = Message<"bff.v1.ListBillingEmailsResponse"> & {
  /**
   * 請求書送付先 (全体 + プロダクト個別)
   *
   * @generated from field: repeated bff.v1.BillingEmail billing_emails = 1;
   */
  billingEmails: BillingEmail[];
};

/**
 * Describes the message bff.v1.ListBillingEmailsResponse.
 * Use `create(ListBillingEmailsResponseSchema)` to create a new message.
 */
export const ListBillingEmailsResponseSchema: GenMessage<ListBillingEmailsResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 11);

/**
 * 全体送付先 + プロダクト個別送付先の保存のリクエスト
 *
 * @generated from message bff.v1.SaveBillingEmailsRequest
 */
export type SaveBillingEmailsRequest = Message<"bff.v1.SaveBillingEmailsRequest"> & {
  /**
   * 保存する請求書送付先
   *
   * @generated from field: repeated bff.v1.BillingEmail billing_emails = 1;
   */
  billingEmails: BillingEmail[];
};

/**
 * Describes the message bff.v1.SaveBillingEmailsRequest.
 * Use `create(SaveBillingEmailsRequestSchema)` to create a new message.
 */
export const SaveBillingEmailsRequestSchema: GenMessage<SaveBillingEmailsRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 12);

/**
 * 全体送付先 + プロダクト個別送付先の保存のレスポンス
 *
 * @generated from message bff.v1.SaveBillingEmailsResponse
 */
export type SaveBillingEmailsResponse = Message<"bff.v1.SaveBillingEmailsResponse"> & {
};

/**
 * Describes the message bff.v1.SaveBillingEmailsResponse.
 * Use `create(SaveBillingEmailsResponseSchema)` to create a new message.
 */
export const SaveBillingEmailsResponseSchema: GenMessage<SaveBillingEmailsResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 13);

/**
 * 設定可能プロダクト一覧取得のリクエスト
 *
 * @generated from message bff.v1.ListBillingEmailEnabledProductsRequest
 */
export type ListBillingEmailEnabledProductsRequest = Message<"bff.v1.ListBillingEmailEnabledProductsRequest"> & {
};

/**
 * Describes the message bff.v1.ListBillingEmailEnabledProductsRequest.
 * Use `create(ListBillingEmailEnabledProductsRequestSchema)` to create a new message.
 */
export const ListBillingEmailEnabledProductsRequestSchema: GenMessage<ListBillingEmailEnabledProductsRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 14);

/**
 * 設定可能プロダクト一覧取得のレスポンス
 *
 * @generated from message bff.v1.ListBillingEmailEnabledProductsResponse
 */
export type ListBillingEmailEnabledProductsResponse = Message<"bff.v1.ListBillingEmailEnabledProductsResponse"> & {
  /**
   * プロダクトID -> プロダクト名
   *
   * @generated from field: map<int32, string> billing_enabled_products = 1;
   */
  billingEnabledProducts: { [key: number]: string };
};

/**
 * Describes the message bff.v1.ListBillingEmailEnabledProductsResponse.
 * Use `create(ListBillingEmailEnabledProductsResponseSchema)` to create a new message.
 */
export const ListBillingEmailEnabledProductsResponseSchema: GenMessage<ListBillingEmailEnabledProductsResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 15);

/**
 * @generated from message bff.v1.ResetMultifactorAuthenticationRequest
 */
export type ResetMultifactorAuthenticationRequest = Message<"bff.v1.ResetMultifactorAuthenticationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bff.v1.ResetMultifactorAuthenticationRequest.
 * Use `create(ResetMultifactorAuthenticationRequestSchema)` to create a new message.
 */
export const ResetMultifactorAuthenticationRequestSchema: GenMessage<ResetMultifactorAuthenticationRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 16);

/**
 * @generated from message bff.v1.ResetMultifactorAuthenticationResponse
 */
export type ResetMultifactorAuthenticationResponse = Message<"bff.v1.ResetMultifactorAuthenticationResponse"> & {
};

/**
 * Describes the message bff.v1.ResetMultifactorAuthenticationResponse.
 * Use `create(ResetMultifactorAuthenticationResponseSchema)` to create a new message.
 */
export const ResetMultifactorAuthenticationResponseSchema: GenMessage<ResetMultifactorAuthenticationResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 17);

/**
 * @generated from message bff.v1.UnlockAccountRequest
 */
export type UnlockAccountRequest = Message<"bff.v1.UnlockAccountRequest"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;
};

/**
 * Describes the message bff.v1.UnlockAccountRequest.
 * Use `create(UnlockAccountRequestSchema)` to create a new message.
 */
export const UnlockAccountRequestSchema: GenMessage<UnlockAccountRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 18);

/**
 * @generated from message bff.v1.UnlockAccountResponse
 */
export type UnlockAccountResponse = Message<"bff.v1.UnlockAccountResponse"> & {
};

/**
 * Describes the message bff.v1.UnlockAccountResponse.
 * Use `create(UnlockAccountResponseSchema)` to create a new message.
 */
export const UnlockAccountResponseSchema: GenMessage<UnlockAccountResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 19);

/**
 * 新基盤(M2M)APIキー一覧取得のリクエスト
 *
 * @generated from message bff.v1.ListApiKeysRequest
 */
export type ListApiKeysRequest = Message<"bff.v1.ListApiKeysRequest"> & {
};

/**
 * Describes the message bff.v1.ListApiKeysRequest.
 * Use `create(ListApiKeysRequestSchema)` to create a new message.
 */
export const ListApiKeysRequestSchema: GenMessage<ListApiKeysRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 20);

/**
 * 新基盤(M2M)APIキー一覧取得のレスポンス
 *
 * @generated from message bff.v1.ListApiKeysResponse
 */
export type ListApiKeysResponse = Message<"bff.v1.ListApiKeysResponse"> & {
  /**
   * APIキー一覧
   *
   * @generated from field: repeated bff.v1.ApiKey api_keys = 1;
   */
  apiKeys: ApiKey[];
};

/**
 * Describes the message bff.v1.ListApiKeysResponse.
 * Use `create(ListApiKeysResponseSchema)` to create a new message.
 */
export const ListApiKeysResponseSchema: GenMessage<ListApiKeysResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 21);

/**
 * 新基盤(M2M)APIキー詳細取得のリクエスト
 *
 * @generated from message bff.v1.GetApiKeyRequest
 */
export type GetApiKeyRequest = Message<"bff.v1.GetApiKeyRequest"> & {
  /**
   * APIキーID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bff.v1.GetApiKeyRequest.
 * Use `create(GetApiKeyRequestSchema)` to create a new message.
 */
export const GetApiKeyRequestSchema: GenMessage<GetApiKeyRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 22);

/**
 * 新基盤(M2M)APIキー詳細取得のレスポンス
 *
 * @generated from message bff.v1.GetApiKeyResponse
 */
export type GetApiKeyResponse = Message<"bff.v1.GetApiKeyResponse"> & {
  /**
   * APIキー詳細
   *
   * @generated from field: bff.v1.ApiKey api_key = 1;
   */
  apiKey?: ApiKey;
};

/**
 * Describes the message bff.v1.GetApiKeyResponse.
 * Use `create(GetApiKeyResponseSchema)` to create a new message.
 */
export const GetApiKeyResponseSchema: GenMessage<GetApiKeyResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 23);

/**
 * 新基盤(M2M)APIキーに付与できるロール一覧取得のリクエスト
 *
 * @generated from message bff.v1.ListApiKeyRolesRequest
 */
export type ListApiKeyRolesRequest = Message<"bff.v1.ListApiKeyRolesRequest"> & {
  /**
   * 絞り込みクエリ。ロール名・説明・スコープ・パーミッション名/説明・エンドポイント(メソッド パス・用途)への部分一致(大文字小文字は区別しない)。空は全件
   *
   * @generated from field: string query = 1;
   */
  query: string;
};

/**
 * Describes the message bff.v1.ListApiKeyRolesRequest.
 * Use `create(ListApiKeyRolesRequestSchema)` to create a new message.
 */
export const ListApiKeyRolesRequestSchema: GenMessage<ListApiKeyRolesRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 24);

/**
 * 新基盤(M2M)APIキーに付与できるロール一覧取得のレスポンス
 *
 * @generated from message bff.v1.ListApiKeyRolesResponse
 */
export type ListApiKeyRolesResponse = Message<"bff.v1.ListApiKeyRolesResponse"> & {
  /**
   * ロール一覧(内部用・非推奨ロールは含まない)
   *
   * @generated from field: repeated bff.v1.ApiKeyRole roles = 1;
   */
  roles: ApiKeyRole[];
};

/**
 * Describes the message bff.v1.ListApiKeyRolesResponse.
 * Use `create(ListApiKeyRolesResponseSchema)` to create a new message.
 */
export const ListApiKeyRolesResponseSchema: GenMessage<ListApiKeyRolesResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 25);

/**
 * 新基盤(M2M)APIキーに付与できるロール取得のリクエスト
 *
 * @generated from message bff.v1.GetApiKeyRoleRequest
 */
export type GetApiKeyRoleRequest = Message<"bff.v1.GetApiKeyRoleRequest"> & {
  /**
   * ロールID(UUID)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bff.v1.GetApiKeyRoleRequest.
 * Use `create(GetApiKeyRoleRequestSchema)` to create a new message.
 */
export const GetApiKeyRoleRequestSchema: GenMessage<GetApiKeyRoleRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 26);

/**
 * 新基盤(M2M)APIキーに付与できるロール取得のレスポンス
 *
 * @generated from message bff.v1.GetApiKeyRoleResponse
 */
export type GetApiKeyRoleResponse = Message<"bff.v1.GetApiKeyRoleResponse"> & {
  /**
   * ロール詳細
   *
   * @generated from field: bff.v1.ApiKeyRole role = 1;
   */
  role?: ApiKeyRole;
};

/**
 * Describes the message bff.v1.GetApiKeyRoleResponse.
 * Use `create(GetApiKeyRoleResponseSchema)` to create a new message.
 */
export const GetApiKeyRoleResponseSchema: GenMessage<GetApiKeyRoleResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 27);

/**
 * 新基盤(M2M)APIキー発行のリクエスト(有効期限は expires_at か no_expiration のどちらか一方を必ず指定する)
 *
 * @generated from message bff.v1.CreateApiKeyRequest
 */
export type CreateApiKeyRequest = Message<"bff.v1.CreateApiKeyRequest"> & {
  /**
   * APIキー名
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 付与するロール名のリスト
   *
   * @generated from field: repeated string role_names = 2;
   */
  roleNames: string[];

  /**
   * 有効期限(no_expiration = false のとき必須)
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;

  /**
   * 無期限にする(true のとき expires_at は指定不可)
   *
   * @generated from field: bool no_expiration = 4;
   */
  noExpiration: boolean;
};

/**
 * Describes the message bff.v1.CreateApiKeyRequest.
 * Use `create(CreateApiKeyRequestSchema)` to create a new message.
 */
export const CreateApiKeyRequestSchema: GenMessage<CreateApiKeyRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 28);

/**
 * 新基盤(M2M)APIキー発行のレスポンス
 *
 * @generated from message bff.v1.CreateApiKeyResponse
 */
export type CreateApiKeyResponse = Message<"bff.v1.CreateApiKeyResponse"> & {
  /**
   * 作成されたAPIキー情報
   *
   * @generated from field: bff.v1.ApiKey api_key = 1;
   */
  apiKey?: ApiKey;

  /**
   * 発行されたAPIキーの生の値(この一度のみ取得可能)
   *
   * @generated from field: string raw_key = 2;
   */
  rawKey: string;
};

/**
 * Describes the message bff.v1.CreateApiKeyResponse.
 * Use `create(CreateApiKeyResponseSchema)` to create a new message.
 */
export const CreateApiKeyResponseSchema: GenMessage<CreateApiKeyResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 29);

/**
 * 新基盤(M2M)APIキー変更のリクエスト(name / role_names / 有効期限はすべて指定した値で上書きする)
 * 有効期限は expires_at か no_expiration のどちらか一方を必ず指定する
 *
 * @generated from message bff.v1.UpdateApiKeyRequest
 */
export type UpdateApiKeyRequest = Message<"bff.v1.UpdateApiKeyRequest"> & {
  /**
   * APIキーID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * APIキー名
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 付与するロール名のリスト
   *
   * @generated from field: repeated string role_names = 3;
   */
  roleNames: string[];

  /**
   * 有効期限(no_expiration = false のとき必須)
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;

  /**
   * 無期限にする(true のとき expires_at は指定不可)
   *
   * @generated from field: bool no_expiration = 5;
   */
  noExpiration: boolean;
};

/**
 * Describes the message bff.v1.UpdateApiKeyRequest.
 * Use `create(UpdateApiKeyRequestSchema)` to create a new message.
 */
export const UpdateApiKeyRequestSchema: GenMessage<UpdateApiKeyRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 30);

/**
 * 新基盤(M2M)APIキー変更のレスポンス
 *
 * @generated from message bff.v1.UpdateApiKeyResponse
 */
export type UpdateApiKeyResponse = Message<"bff.v1.UpdateApiKeyResponse"> & {
  /**
   * 変更後のAPIキー情報
   *
   * @generated from field: bff.v1.ApiKey api_key = 1;
   */
  apiKey?: ApiKey;
};

/**
 * Describes the message bff.v1.UpdateApiKeyResponse.
 * Use `create(UpdateApiKeyResponseSchema)` to create a new message.
 */
export const UpdateApiKeyResponseSchema: GenMessage<UpdateApiKeyResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 31);

/**
 * 新基盤(M2M)APIキー失効のリクエスト(即時失効のみ)
 *
 * @generated from message bff.v1.RevokeApiKeyRequest
 */
export type RevokeApiKeyRequest = Message<"bff.v1.RevokeApiKeyRequest"> & {
  /**
   * APIキーID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bff.v1.RevokeApiKeyRequest.
 * Use `create(RevokeApiKeyRequestSchema)` to create a new message.
 */
export const RevokeApiKeyRequestSchema: GenMessage<RevokeApiKeyRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 32);

/**
 * 新基盤(M2M)APIキー失効のレスポンス(失効後の状態は GetApiKey で再取得する)
 *
 * @generated from message bff.v1.RevokeApiKeyResponse
 */
export type RevokeApiKeyResponse = Message<"bff.v1.RevokeApiKeyResponse"> & {
};

/**
 * Describes the message bff.v1.RevokeApiKeyResponse.
 * Use `create(RevokeApiKeyResponseSchema)` to create a new message.
 */
export const RevokeApiKeyResponseSchema: GenMessage<RevokeApiKeyResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 33);

/**
 * @generated from message bff.v1.SuspendMemberRequest
 */
export type SuspendMemberRequest = Message<"bff.v1.SuspendMemberRequest"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;
};

/**
 * Describes the message bff.v1.SuspendMemberRequest.
 * Use `create(SuspendMemberRequestSchema)` to create a new message.
 */
export const SuspendMemberRequestSchema: GenMessage<SuspendMemberRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 34);

/**
 * @generated from message bff.v1.SuspendMemberResponse
 */
export type SuspendMemberResponse = Message<"bff.v1.SuspendMemberResponse"> & {
};

/**
 * Describes the message bff.v1.SuspendMemberResponse.
 * Use `create(SuspendMemberResponseSchema)` to create a new message.
 */
export const SuspendMemberResponseSchema: GenMessage<SuspendMemberResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 35);

/**
 * @generated from message bff.v1.UnsuspendMemberRequest
 */
export type UnsuspendMemberRequest = Message<"bff.v1.UnsuspendMemberRequest"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;
};

/**
 * Describes the message bff.v1.UnsuspendMemberRequest.
 * Use `create(UnsuspendMemberRequestSchema)` to create a new message.
 */
export const UnsuspendMemberRequestSchema: GenMessage<UnsuspendMemberRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 36);

/**
 * @generated from message bff.v1.UnsuspendMemberResponse
 */
export type UnsuspendMemberResponse = Message<"bff.v1.UnsuspendMemberResponse"> & {
};

/**
 * Describes the message bff.v1.UnsuspendMemberResponse.
 * Use `create(UnsuspendMemberResponseSchema)` to create a new message.
 */
export const UnsuspendMemberResponseSchema: GenMessage<UnsuspendMemberResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_admin, 37);

/**
 * @generated from service bff.v1.BffAdminService
 */
export const BffAdminService: GenService<{
  /**
   * @generated from rpc bff.v1.BffAdminService.SendInvitation
   */
  sendInvitation: {
    methodKind: "unary";
    input: typeof SendInvitationRequestSchema;
    output: typeof SendInvitationResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffAdminService.GetMember
   */
  getMember: {
    methodKind: "unary";
    input: typeof GetMemberRequestSchema;
    output: typeof GetMemberResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffAdminService.SaveMember
   */
  saveMember: {
    methodKind: "unary";
    input: typeof SaveMemberRequestSchema;
    output: typeof SaveMemberResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffAdminService.AgreeToTerm
   */
  agreeToTerm: {
    methodKind: "unary";
    input: typeof AgreeToTermRequestSchema;
    output: typeof AgreeToTermResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffAdminService.ListPendingTerms
   */
  listPendingTerms: {
    methodKind: "unary";
    input: typeof ListPendingTermsRequestSchema;
    output: typeof ListPendingTermsResponseSchema;
  },
  /**
   * 全体送付先 + プロダクト個別送付先の一覧を取得する
   *
   * @generated from rpc bff.v1.BffAdminService.ListBillingEmails
   */
  listBillingEmails: {
    methodKind: "unary";
    input: typeof ListBillingEmailsRequestSchema;
    output: typeof ListBillingEmailsResponseSchema;
  },
  /**
   * 全体送付先 + プロダクト個別送付先をまとめて保存する
   *
   * @generated from rpc bff.v1.BffAdminService.SaveBillingEmails
   */
  saveBillingEmails: {
    methodKind: "unary";
    input: typeof SaveBillingEmailsRequestSchema;
    output: typeof SaveBillingEmailsResponseSchema;
  },
  /**
   * プロダクト個別送付先を設定可能なプロダクト一覧を取得する
   * (組織が有効なベースプランを契約しており、かつ請求書送付先設定が有効なプロダクト)
   *
   * @generated from rpc bff.v1.BffAdminService.ListBillingEmailEnabledProducts
   */
  listBillingEmailEnabledProducts: {
    methodKind: "unary";
    input: typeof ListBillingEmailEnabledProductsRequestSchema;
    output: typeof ListBillingEmailEnabledProductsResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffAdminService.ResetMultifactorAuthentication
   */
  resetMultifactorAuthentication: {
    methodKind: "unary";
    input: typeof ResetMultifactorAuthenticationRequestSchema;
    output: typeof ResetMultifactorAuthenticationResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffAdminService.UnlockAccount
   */
  unlockAccount: {
    methodKind: "unary";
    input: typeof UnlockAccountRequestSchema;
    output: typeof UnlockAccountResponseSchema;
  },
  /**
   * 新基盤(M2M)APIキーの一覧を取得する(組織IDはリクエストコンテキストから解決)
   *
   * @generated from rpc bff.v1.BffAdminService.ListApiKeys
   */
  listApiKeys: {
    methodKind: "unary";
    input: typeof ListApiKeysRequestSchema;
    output: typeof ListApiKeysResponseSchema;
  },
  /**
   * 新基盤(M2M)APIキーの詳細を取得する(自組織のキーのみ)
   *
   * @generated from rpc bff.v1.BffAdminService.GetApiKey
   */
  getApiKey: {
    methodKind: "unary";
    input: typeof GetApiKeyRequestSchema;
    output: typeof GetApiKeyResponseSchema;
  },
  /**
   * 新基盤(M2M)APIキーに付与できるロールの一覧を取得する
   *
   * @generated from rpc bff.v1.BffAdminService.ListApiKeyRoles
   */
  listApiKeyRoles: {
    methodKind: "unary";
    input: typeof ListApiKeyRolesRequestSchema;
    output: typeof ListApiKeyRolesResponseSchema;
  },
  /**
   * 新基盤(M2M)APIキーに付与できるロールをロールIDで取得する(内部用・非推奨・契約外スコープのロールは NotFound)
   *
   * @generated from rpc bff.v1.BffAdminService.GetApiKeyRole
   */
  getApiKeyRole: {
    methodKind: "unary";
    input: typeof GetApiKeyRoleRequestSchema;
    output: typeof GetApiKeyRoleResponseSchema;
  },
  /**
   * 新基盤(M2M)APIキーを発行する(組織IDはリクエストコンテキストから解決)
   * raw_key は発行時の1回のみレスポンスに含まれ、以後取得できない
   *
   * @generated from rpc bff.v1.BffAdminService.CreateApiKey
   */
  createApiKey: {
    methodKind: "unary";
    input: typeof CreateApiKeyRequestSchema;
    output: typeof CreateApiKeyResponseSchema;
  },
  /**
   * 新基盤(M2M)APIキーの名前・ロール・有効期限を変更する(自組織のキーのみ)
   *
   * @generated from rpc bff.v1.BffAdminService.UpdateApiKey
   */
  updateApiKey: {
    methodKind: "unary";
    input: typeof UpdateApiKeyRequestSchema;
    output: typeof UpdateApiKeyResponseSchema;
  },
  /**
   * 新基盤(M2M)APIキーを即時失効させる(自組織のキーのみ)。失効後は元に戻せない
   *
   * @generated from rpc bff.v1.BffAdminService.RevokeApiKey
   */
  revokeApiKey: {
    methodKind: "unary";
    input: typeof RevokeApiKeyRequestSchema;
    output: typeof RevokeApiKeyResponseSchema;
  },
  /**
   * アカウントを一時停止（サスペンド）する
   *
   * @generated from rpc bff.v1.BffAdminService.SuspendMember
   */
  suspendMember: {
    methodKind: "unary";
    input: typeof SuspendMemberRequestSchema;
    output: typeof SuspendMemberResponseSchema;
  },
  /**
   * アカウントの一時停止を解除する
   *
   * @generated from rpc bff.v1.BffAdminService.UnsuspendMember
   */
  unsuspendMember: {
    methodKind: "unary";
    input: typeof UnsuspendMemberRequestSchema;
    output: typeof UnsuspendMemberResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bff_v1_admin, 0);

